<section class="hero">
	<p-carousel
		[value]="slides()"
		[numVisible]="1"
		[numScroll]="1"
		[circular]="true"
		[showNavigators]="true"
		[showIndicators]="true"
		[autoplayInterval]="6500"
		[responsiveOptions]="responsiveOptions">
		<ng-template let-slide #item>
			<article class="hero-slide">
				<img class="hero-slide__image" [src]="slide.image" [alt]="slide.title" />
				<div class="hero-slide__overlay"></div>

				<div class="hero-slide__content">
					<h1>{{ slide.title }}</h1>
					<p class="hero-slide__description">{{ slide.description }}</p>

					<div class="hero-slide__actions">
						<button class="btn btn-primary">{{ slide.primaryActionLabel }}</button>
					</div>
				</div>
			</article>
		</ng-template>
	</p-carousel>
</section>
